import React from 'react';
import { dragManager } from '@codametrix/ui-common';
import { BiomeIcon, IconName } from '@codametrix/verdigris';
import { canDropOnto } from './can-drop';
import { Accordion, Conditional } from '@codametrix/ui-components';

const draggedCodesManager = dragManager.load('codes');
/**
 * React component that displays a build body
 * @param codableTransaction
 * @param onDropHandler
 * @param onAccordionAction
 * @param items
 * @param onDelete
 * @param editable
 * @returns
 */
export const TransactionBuildBody = (
  codableTransaction: CMxCommonApp.CodableTransaction,
  onDropHandler: (
    dropAction: CMxCommonApp.DroppedAction<CMxCommonApp.ChargeSessionCode>
  ) => void,
  onAccordionAction: (action: any, item: any) => void,
  items: any,
  onDelete: (ev: any) => void,
  editable: boolean
) => {
  return (
    <div className="transaction-bodyV2">
      <div className="charge-details-header-section">
        <h5>Charge details</h5>
        <Conditional on={editable}>
          <div className="charge-delete-section" onClick={(e) => onDelete(e)}>
            <BiomeIcon
              iconName={IconName.Trash}
              iconSize="16"
              iconClass="charge-delete-icon qa-charge-delete-icon"
              titleText="Delete charge"
            />
          </div>
        </Conditional>
      </div>
      <div>
        {items.length ? (
          <Accordion
            onAction={onAccordionAction}
            dragManager={draggedCodesManager}
            canDropOnto={canDropOnto}
            onDropHandler={onDropHandler}
            selectable={true}
            droppable={true}
            items={items}
            errors={codableTransaction?.procedure?.errorMessages ?? []}
          />
        ) : editable ? (
          <div className="empty-message editable">
            Add codes in the above section.
          </div>
        ) : (
          <div className="empty-message uneditable">No codes selected</div>
        )}
      </div>
    </div>
  );
};
